/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RealtimeEventsControllerGetRealtimeAuthTokenQueryResponse } from "../../models/realtimeEventsController/RealtimeEventsControllerGetRealtimeAuthToken";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { realtimeEventsControllerGetRealtimeAuthToken } from "../../clients/realtime-eventsService/realtimeEventsControllerGetRealtimeAuthToken";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const realtimeEventsControllerGetRealtimeAuthTokenQueryKey = () => [{
  url: '/api/v1/realtime/auth'
}] as const;
export type RealtimeEventsControllerGetRealtimeAuthTokenQueryKey = ReturnType<typeof realtimeEventsControllerGetRealtimeAuthTokenQueryKey>;
export function realtimeEventsControllerGetRealtimeAuthTokenQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = realtimeEventsControllerGetRealtimeAuthTokenQueryKey();
  return queryOptions<RealtimeEventsControllerGetRealtimeAuthTokenQueryResponse, ResponseErrorConfig<Error>, RealtimeEventsControllerGetRealtimeAuthTokenQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return realtimeEventsControllerGetRealtimeAuthToken(config);
    }
  });
}

/**
 * @summary Get realtime authentication token
 * {@link /api/v1/realtime/auth}
 */
export function useRealtimeEventsControllerGetRealtimeAuthToken<TData = RealtimeEventsControllerGetRealtimeAuthTokenQueryResponse, TQueryData = RealtimeEventsControllerGetRealtimeAuthTokenQueryResponse, TQueryKey extends QueryKey = RealtimeEventsControllerGetRealtimeAuthTokenQueryKey>(options: {
  query?: Partial<QueryObserverOptions<RealtimeEventsControllerGetRealtimeAuthTokenQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? realtimeEventsControllerGetRealtimeAuthTokenQueryKey();
  const query = useQuery({
    ...realtimeEventsControllerGetRealtimeAuthTokenQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}